// Point d'entrée unique pour accéder aux composants des jeux.
// Scalable : Ajouter un jeu = ajouter un bloc ici (1 import + 1 case).

import {
  getOrigamiStageComponent,
  listOrigamiStageComponents,
} from "./origami/stageRegistry";

// Convention: gameId = number (1 = Origami, etc.)
export function getStageComponent(gameId, componentName) {
  switch (Number(gameId)) {
    case 1:
      return getOrigamiStageComponent(componentName);

    default:
      return null;
  }
}

export function listStageComponents(gameId) {
  switch (Number(gameId)) {
    case 1:
      return listOrigamiStageComponents();

    default:
      return [];
  }
}
